<template>
<div class="breadcrumbs">
  <div class="breadcrumbs__container">
    <router-link class="breadcrumbs__link" to="/" exact>
      Главная
    </router-link>

    <template v-if="newsPage">
      <router-link :to="{ name: 'news' }" class="breadcrumbs__link">
        <div class="breadcrumbs__arrow">
          ›
        </div>
        Новости
      </router-link>
      <router-link to="" class="breadcrumbs__link">
        <div class="breadcrumbs__arrow">
          ›
        </div>
        <slot></slot>
      </router-link>
    </template>

    <template v-else>
      <router-link v-for="link, i in breadcrumbsLinks"
       :key="i" :to="link" class="breadcrumbs__link">

        <div class="breadcrumbs__arrow" v-show="link.meta.title !== ''">
          ›
        </div>
        {{link.meta.title}}
      </router-link>
    </template>
  </div>
</div>
</template>

<script>
export default {
  props: {
    newsPage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      arrowShow: false,
    };
  },
  computed: {
    breadcrumbsLinks() {
      const tmp = [];
      if (this.$route.matched) {
        this.$route.matched.forEach((link) => {
          tmp.push({
            meta: {
              title: 'Not found',
            },
            ...link,
          });
        });
      }
      if (tmp.length === 0) {
        tmp.push({
          path: '/',
          meta: {
            title: 'CLASS – система поддержки принятия решений на основе полного и объективного анализа временных рядов пространственных данных',
          },
        });
      }
      return tmp;
    },
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
$light-gray: #D5D6D7;
$orange: #F8A81B;
$violet: #8293E8;
$sky-blue: #5598CF;
$green: #27AE60;
$coral: #FF7D75;

.breadcrumbs {
  color: white;
  background: #4DB6BC;
  position: relative;
  z-index: 10;

  &.breadcrumbs-bg_orange {
    background: $orange;
  }

  &.breadcrumbs-bg_violet {
    background: $violet;
  }

  &.breadcrumbs-bg_sky {
    background: $sky-blue;
  }

  &.breadcrumbs-bg_green {
    background: $green;
  }

  &.breadcrumbs-bg_coral {
    background: $coral;
  }

  &__container {
    padding: 12px 180px;
    display: flex;

    @media (max-width: 1275px) {
      padding: 12px 50px;
    }

    @media (max-width: 480px) {
      padding: 12px 20px;
    }

    @media (max-width: 380px) {
      flex-wrap: wrap;
    }
  }

  &__link {
    display: flex;
  }

  &__arrow {
    padding: 0 5px;
  }
}
</style>
